/////-------通信逻辑------////////
/** 1. 当前页面 post  ready事件到上层页面，
 *  2. 上层页面接收到 ready 事件后，会发送postData事件，
 *  3. app实例接收 data事件后，跳转路由，再次分发data事件，触发订阅函数
 */
/**
 * 向父级发送消息
 */
import Vue from 'vue';

// 事件中心，用于转发事件
const EventCenter = new Vue();
EventCenter['POST_MESSAGE'] = 'POST_MESSAGE'; // event type

const postMessage = function(type, content) {
    let msg = {
        type: type,
        content: content
    };
    if (window.parent) {
        window.parent.postMessage(msg, '*');
        console.log('post message to parent.data:', msg);
    }
};
/**
 * 注册接收消息
 */
const types = ['data'];
const registerGetMessage = function(callback) {
    window.addEventListener(
        'message',
        event => {
            const msg = event.data;
            if (!msg || !types.includes(msg.type)) {
                // 接受指定的事件
                return;
            }
            console.log('report loader get message from parent. type:', msg.type, 'content:', msg.content);
            if (typeof callback === 'function') {
                callback(msg);
            }
            if (msg.type == types[0]) {
                // 接收到事件后，延迟一段时间通过事件中心分发该事件
                setTimeout(() => {
                    EventCenter.$emit(EventCenter.POST_MESSAGE, msg);
                }, 10);
            } else {
                // 'clear','scroll' 两个事件，立即传递，data事件延迟传递
                EventCenter.$emit(EventCenter.POST_MESSAGE, msg);
            }
        },
        false
    );
};
export { postMessage, registerGetMessage, EventCenter };
